import { render, staticRenderFns } from "./danGoodsApplyMine.vue?vue&type=template&id=a70a9146&scoped=true"
import script from "./danGoodsApplyMine.vue?vue&type=script&lang=js"
export * from "./danGoodsApplyMine.vue?vue&type=script&lang=js"
import style0 from "./danGoodsApplyMine.vue?vue&type=style&index=0&id=a70a9146&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70a9146",
  null
  
)

export default component.exports